import {inject} from '@angular/core';
import {Actions, ofType} from '@ngrx/effects';
import {createFunctionalEffect} from '@shared/utils/effects.helper';
import {mapOdApiActions} from '@utils/map-od-api-actions.function';
import {switchMap} from 'rxjs';

import {FavoritesActions} from './favorites.actions';
import {FavoritesApi} from './favorites.api';

export namespace FavoritesEffects {
  export const getFavorites$ = createFunctionalEffect(
    (actions$ = inject(Actions), api = inject(FavoritesApi)) =>
      actions$.pipe(
        ofType(FavoritesActions.getFavorites.requested),
        switchMap(() =>
          api
            .getFavorites()
            .pipe(mapOdApiActions(FavoritesActions.getFavorites))
        )
      )
  );
}
